import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Table from 'components/table/SimpleTable'
import projectSelectors from 'store/selectors/project'
import projectActions from 'store/modules/project'
import routerActions from 'store/modules/router'

import {
  fullUrl,
} from 'utils/url'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    flexGrow: 1,
  },
  addButton: {
    flexGrow: 0,
  },
  actionButton: {
    margin: theme.spacing(1),
  },
  description: {
    color: '#999'
  }
}))

const FIELDS = [{
  title: 'Name',
  name: 'name',
}, {
  title: 'URL',
  name: 'url',
}, {
  title: 'Description',
  name: 'description',
}]

const Projects = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const data = useSelector(projectSelectors.projects)
  const projectId = useSelector(projectSelectors.currentProjectId)

  const onView = useCallback((item) => {
    dispatch(projectActions.switchProject(item.id, false))
  }, [])

  const onEdit = useCallback((item) => {
    dispatch(projectActions.setCurrentProjectId(item.id))
    dispatch(routerActions.navigateTo('admin.settings'))
  }, [])

  const onOpenBookingForms = useCallback((item) => {
    dispatch(projectActions.setCurrentProjectId(item.id))
    dispatch(routerActions.navigateTo('admin.bookingforms'))
  }, [])

  const tableData = useMemo(() => {
    return data.map(project => {
      const url = fullUrl(project)
      return {
        id: project.id,
        name: `${project.name} ${projectId == project.id ? '(*)' : ''}`,
        description: (
          <Typography variant="caption" className={ classes.description }>
            { project.meta.description }
          </Typography>
        ),
        url: (
          <a href={ url } target="_blank">{ url }</a>
        )
      }
    })
  }, [
    projectId,
    data,
  ])

  const getActions = useCallback((item) => {
    return (
      <>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ (e) => {
            onView(item)
            return false
          }}
        >
          Switch
        </Button>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ (e) => {
            onView(item)
            onEdit(item)
            return false
          }}
        >
          Edit
        </Button>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ (e) => {
            onView(item)
            onOpenBookingForms(item)
            return false
          }}
        >
          Booking Forms
        </Button>
      </>
    )
  })

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography gutterBottom variant="h6">
            Projects
          </Typography>
        </div>
      </div>
      <div className={ classes.content }>
        <Table
          data={ tableData }
          fields={ FIELDS }
          getActions={ getActions }
        />
      </div>
    </div>
  )
}

export default Projects